import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ActionBar,
   ButtonVariant,
   ModalWidth,
   ShowModalEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { healthcarePracticeTranslationKeys } from '../../../translations';

import { useCurrentHealthcarePracticeUpdateCommand } from './HealthcarePracticeUpdateAction.hooks';
import { HealthcarePracticeUpdateFormController } from './HealthcarePracticeUpdateForm.types';

type HealthcarePracticeUpdateActionProps = Pick<HealthcarePracticeUpdateFormController, 'trigger' | 'handleSubmit'> & {
   readonly onDataChanged: () => Promise<void>;
   readonly showWarningBeforeUpdate: boolean;
};

export const HealthcarePracticeUpdateAction = (props: HealthcarePracticeUpdateActionProps): JSX.Element => {
   const { executeAsync: updateHealthcarePractice } = useCurrentHealthcarePracticeUpdateCommand(props.onDataChanged);

   return (
      <ValidateFormEventInterceptor trigger={props.trigger}>
         <ShowModalEventInterceptor
            testId={'overwritePracticeDataWarning'}
            shouldShowModal={props.showWarningBeforeUpdate}
            title={healthcarePracticeTranslationKeys.savingPracticeData}
            content={healthcarePracticeTranslationKeys.overwritePracticeDataMessage}
            confirmationButtonLabel={commonTranslationKeys.save}
            modalWidth={ModalWidth.NORMAL}
         >
            <ActionBar.PrimaryButton
               testId='practiceDataUpdate'
               label={healthcarePracticeTranslationKeys.updatePracticeData}
               onClick={props.handleSubmit(updateHealthcarePractice)}
               variant={ButtonVariant.PRIMARY}
               order={1}
               blockingOperation
            />
         </ShowModalEventInterceptor>
      </ValidateFormEventInterceptor>
   );
};
